module.exports = __webpack_public_path__ + "img/09.ef49fdc7.jpg";